import asyncAction from 'store/asyncAction';

const FETCH_SETTINGS = asyncAction('FETCH_SETTINGS');

export default FETCH_SETTINGS;
